/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PublishSurveyDto,
  SatisfactionSurveyResponse,
  SendSurveyDto,
  SurveySendResponse,
  SurveySummaryResponse,
  SurveysList200,
  SurveysListParams,
  SurveysSummaryParams
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * نظرسنجی‌های فرستاده‌شده و پاسخ‌داده‌شده، با فیلتر وضعیت، بیمار، پزشک، امتیاز و بازهٔ تاریخ. با publishable=true فقط پاسخ‌هایی می‌آیند که بیمار اجازهٔ انتشارشان را داده و هنوز منتشر نشده‌اند.
 * @summary فهرست نظرسنجی‌ها
 */
export const surveysList = (
    params?: SurveysListParams,
 signal?: AbortSignal
) => {


      return apiClient<SurveysList200>(
      {url: `/api/v1/surveys`, method: 'GET',
        params, signal
    },
      );
    }




export const getSurveysListQueryKey = (params?: SurveysListParams,) => {
    return [
    `/api/v1/surveys`, ...(params ? [params] : [])
    ] as const;
    }


export const getSurveysListQueryOptions = <TData = Awaited<ReturnType<typeof surveysList>>, TError = void>(params?: SurveysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveysListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveysList>>> = ({ signal }) => surveysList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SurveysListQueryResult = NonNullable<Awaited<ReturnType<typeof surveysList>>>
export type SurveysListQueryError = void


export function useSurveysList<TData = Awaited<ReturnType<typeof surveysList>>, TError = void>(
 params: undefined |  SurveysListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysList>>,
          TError,
          Awaited<ReturnType<typeof surveysList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysList<TData = Awaited<ReturnType<typeof surveysList>>, TError = void>(
 params?: SurveysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysList>>,
          TError,
          Awaited<ReturnType<typeof surveysList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysList<TData = Awaited<ReturnType<typeof surveysList>>, TError = void>(
 params?: SurveysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست نظرسنجی‌ها
 */

export function useSurveysList<TData = Awaited<ReturnType<typeof surveysList>>, TError = void>(
 params?: SurveysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSurveysListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * لینک یک‌بارمصرف و دارای انقضا می‌سازد و پیامک می‌کند. برای هر جلسه فقط یک نظرسنجی باز وجود دارد، پس دو بار کلیک کردن دو لینک نمی‌سازد. بیماری که انصراف از پیامک داده، نظرسنجی و لینکش را می‌گیرد ولی پیامک برایش نمی‌رود — پاسخ در smsSkippedReason می‌آید. لینک خام فقط همین یک بار برگردانده می‌شود؛ در دیتابیس فقط هش آن ذخیره است.
 * @summary ارسال نظرسنجی برای یک جلسه
 */
export const surveysSend = (
    sendSurveyDto: SendSurveyDto,
 signal?: AbortSignal
) => {


      return apiClient<SurveySendResponse>(
      {url: `/api/v1/surveys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSurveyDto, signal
    },
      );
    }




export const getSurveysSendMutationKey = () => ['surveysSend'] as const;

export const getSurveysSendMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysSend>>, TError,SurveysSendMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof surveysSend>>, TError,SurveysSendMutationVariables, TContext> => {

const mutationKey = getSurveysSendMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveysSend>>, SurveysSendMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  surveysSend(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SurveysSendMutationResult = NonNullable<Awaited<ReturnType<typeof surveysSend>>>
    export type SurveysSendMutationBody = SendSurveyDto
    export type SurveysSendMutationError = void
    export type SurveysSendMutationVariables = {data: SendSurveyDto}

    /**
 * @summary ارسال نظرسنجی برای یک جلسه
 */
export const useSurveysSend = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysSend>>, TError,SurveysSendMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof surveysSend>>,
        TError,
        SurveysSendMutationVariables,
        TContext
      > => {
      return useMutation(getSurveysSendMutationOptions(options), queryClient);
    }
    /**
 * میانگین، توزیع امتیازها، نرخ پاسخ و رتبه‌بندی پزشکان و خدمات. مرتب‌سازی بر اساس میانگین است و در تساوی، تعداد پاسخ تعیین‌کننده می‌شود — تا پزشکی با یک امتیاز پنج، بالاتر از پزشکی با چهل پاسخ ۴٫۹ ننشیند.
 * @summary خلاصهٔ رضایت به تفکیک پزشک و خدمت
 */
export const surveysSummary = (
    params?: SurveysSummaryParams,
 signal?: AbortSignal
) => {


      return apiClient<SurveySummaryResponse>(
      {url: `/api/v1/surveys/summary`, method: 'GET',
        params, signal
    },
      );
    }




export const getSurveysSummaryQueryKey = (params?: SurveysSummaryParams,) => {
    return [
    `/api/v1/surveys/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getSurveysSummaryQueryOptions = <TData = Awaited<ReturnType<typeof surveysSummary>>, TError = unknown>(params?: SurveysSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveysSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveysSummary>>> = ({ signal }) => surveysSummary(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SurveysSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof surveysSummary>>>
export type SurveysSummaryQueryError = unknown


export function useSurveysSummary<TData = Awaited<ReturnType<typeof surveysSummary>>, TError = unknown>(
 params: undefined |  SurveysSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysSummary>>,
          TError,
          Awaited<ReturnType<typeof surveysSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysSummary<TData = Awaited<ReturnType<typeof surveysSummary>>, TError = unknown>(
 params?: SurveysSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysSummary>>,
          TError,
          Awaited<ReturnType<typeof surveysSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysSummary<TData = Awaited<ReturnType<typeof surveysSummary>>, TError = unknown>(
 params?: SurveysSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خلاصهٔ رضایت به تفکیک پزشک و خدمت
 */

export function useSurveysSummary<TData = Awaited<ReturnType<typeof surveysSummary>>, TError = unknown>(
 params?: SurveysSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSurveysSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * با نام بیمار، خدمت و پزشک آن جلسه.
 * @summary یک نظرسنجی
 */
export const surveysFindOne = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<SatisfactionSurveyResponse>(
      {url: `/api/v1/surveys/${id}`, method: 'GET', signal
    },
      );
    }




export const getSurveysFindOneQueryKey = (id: string,) => {
    return [
    `/api/v1/surveys/${id}`
    ] as const;
    }


export const getSurveysFindOneQueryOptions = <TData = Awaited<ReturnType<typeof surveysFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveysFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveysFindOne>>> = ({ signal }) => surveysFindOne(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SurveysFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof surveysFindOne>>>
export type SurveysFindOneQueryError = void


export function useSurveysFindOne<TData = Awaited<ReturnType<typeof surveysFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysFindOne>>,
          TError,
          Awaited<ReturnType<typeof surveysFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysFindOne<TData = Awaited<ReturnType<typeof surveysFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof surveysFindOne>>,
          TError,
          Awaited<ReturnType<typeof surveysFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSurveysFindOne<TData = Awaited<ReturnType<typeof surveysFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک نظرسنجی
 */

export function useSurveysFindOne<TData = Awaited<ReturnType<typeof surveysFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveysFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSurveysFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * لینک را باطل می‌کند. نظرسنجی‌ای که پاسخ داده شده لغو نمی‌شود.
 * @summary لغو نظرسنجی
 */
export const surveysCancel = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<SatisfactionSurveyResponse>(
      {url: `/api/v1/surveys/${id}/cancel`, method: 'POST', signal
    },
      );
    }




export const getSurveysCancelMutationKey = () => ['surveysCancel'] as const;

export const getSurveysCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysCancel>>, TError,SurveysCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof surveysCancel>>, TError,SurveysCancelMutationVariables, TContext> => {

const mutationKey = getSurveysCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveysCancel>>, SurveysCancelMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  surveysCancel(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SurveysCancelMutationResult = NonNullable<Awaited<ReturnType<typeof surveysCancel>>>

    export type SurveysCancelMutationError = void
    export type SurveysCancelMutationVariables = {id: string}

    /**
 * @summary لغو نظرسنجی
 */
export const useSurveysCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysCancel>>, TError,SurveysCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof surveysCancel>>,
        TError,
        SurveysCancelMutationVariables,
        TContext
      > => {
      return useMutation(getSurveysCancelMutationOptions(options), queryClient);
    }
    /**
 * سه شرط باید هم‌زمان برقرار باشد: بیمار اجازهٔ انتشار داده باشد، کلینیک انتشار نظرها را در تنظیمات دایرکتوری روشن کرده باشد، و نظر به یک جلسهٔ انجام‌شده وصل باشد. حتی آن‌وقت هم نظر در وضعیت «در انتظار بررسی» ثبت می‌شود و پس از تأیید پلتفرم منتشر می‌گردد. نام نمایشی «مریم ا.» است، نه نام کامل.
 * @summary انتشار نظر در صفحهٔ عمومی کلینیک
 */
export const surveysPublish = (
    id: string,
    publishSurveyDto: PublishSurveyDto,
 signal?: AbortSignal
) => {


      return apiClient<SatisfactionSurveyResponse>(
      {url: `/api/v1/surveys/${id}/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: publishSurveyDto, signal
    },
      );
    }




export const getSurveysPublishMutationKey = () => ['surveysPublish'] as const;

export const getSurveysPublishMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysPublish>>, TError,SurveysPublishMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof surveysPublish>>, TError,SurveysPublishMutationVariables, TContext> => {

const mutationKey = getSurveysPublishMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveysPublish>>, SurveysPublishMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  surveysPublish(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SurveysPublishMutationResult = NonNullable<Awaited<ReturnType<typeof surveysPublish>>>
    export type SurveysPublishMutationBody = PublishSurveyDto
    export type SurveysPublishMutationError = void
    export type SurveysPublishMutationVariables = {id: string;data: PublishSurveyDto}

    /**
 * @summary انتشار نظر در صفحهٔ عمومی کلینیک
 */
export const useSurveysPublish = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveysPublish>>, TError,SurveysPublishMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof surveysPublish>>,
        TError,
        SurveysPublishMutationVariables,
        TContext
      > => {
      return useMutation(getSurveysPublishMutationOptions(options), queryClient);
    }
